import { useToast } from "@chakra-ui/react";
import Check0 from 'assets/icons/check0.svg';
// assets
import Arrow from 'assets/icons/forward.svg';
import Check2 from 'assets/icons/pop-check.svg';
import Back from 'assets/svg/back-arrow.svg';
import Load from "assets/svg/other/loading2.svg";
import Header from 'components/dashHeader';
// components
import Sidemenu from 'components/sidemenu';
import { isDev, isProd } from 'config/constant';
import useAuth from "hooks/useAuth";
import { appendScript, removeScript } from 'hooks/useScript';
//css 
import 'pages/styles/dashboard/Home.css';
import React, { Component, createRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { post } from "util/axiosLib";

const countryMap = (curr) => {
  const mp = {
    ngn: "NG",
    kes: "KE",
    ghs: "GH"
  }

  return mp[String(curr).trim().toLowerCase()] || ""
}
const scriptUrl = "https://checkout.flutterwave.com/v3.js";

function FlutterwaveDeposit(props) {
  const { token, profile } = useAuth();
  const toast = useToast();
  const userData = profile?.data;

  console.log({userData})

  useEffect(() => {
    

  }, [profile?.data])

  if(2+2===4) return null

  return (
    <FlutterwaveDepositClass {...props} userData={profile?.data} token={token} toast={toast} />
  )
}

export default FlutterwaveDeposit


class FlutterwaveDepositClass extends Component {

  FlutterwaveCheckout = createRef()
    constructor(props) {
        super(props);
    
        this.state = {
            popUpClicked: false,
            enterPin:false,
            fiatCurrency: ""
        };
        this.token = this.props.token;
        this.user = this.props.userData;
    }

    isFlutterWaveSupportInCountry() {
      if(isDev) return true
      const ctry = {
        "nigeria": false,
      }
      return ctry[String(this.props.userData?.country).toLowerCase()] ?? true;
    }
  
    componentDidMount() {
      if(!this.isFlutterWaveSupportInCountry()) {
        window.location.replace(
          window.location.origin + "/dashboard/wallet"
        );
      }
      appendScript(scriptUrl);
      this.FlutterwaveCheckout = window.FlutterwaveCheckout;
      const status = window.location.pathname.substr(31);
      this.setState({ status });
    }

    componentWillUnmount() {
      2+2===5 && removeScript(scriptUrl)
    }
    
    handleInputChange = async (event) => {
        const target = event.target;
        const name = target.name;
        const value = target.value;
    
        await this.setState({
          [name]: value,
        });
    
        const errmsg = document.getElementById("error-info2");
        errmsg.classList.remove("err-auth-on");
        this.setState({ incorrectError: " " });
    
        if (name === "amount") {
          const numberRegex = /(?=[a-zA-Z])/;
          if(numberRegex.test(value) || value < 0){
            const errmsg = document.getElementById("error-info2");
            errmsg.classList.add("err-auth-on");
            this.setState({ incorrectError: "Please enter only valid numbers" });
          }
    
        }

        if (this.state.fiatCurrency!=="" && this.state.amount > 0) {
          const ebtn = document.getElementById("actionBtn");
          await ebtn.classList.remove("e-disable");
        } else {
          const ebtn = document.getElementById("actionBtn");
          await ebtn.classList.add("e-disable");
        }
        // const loaded2 = document.getElementById("loadla");
        // loaded2.classList.add("load-aa-on");
      
      };

    handleSubmit = async (event) => {
        event.preventDefault();
        
        // this.setState({ 
        //     enterPin: true
        // });
       
        const ebtn = document.getElementById("actionBtn");
        ebtn.classList.add("e-disable");
        const errmsg = document.getElementById("error-info2");

        errmsg.classList.remove("err-auth-on");
        this.setState({ incorrectError: " " });
        //loading..
        const loaded2 = document.getElementById("loadla");
        loaded2.classList.add("load-aa-on");
    
        try {
          event.preventDefault();
          const obj = {
            currency: this.state.fiatCurrency,
            amount: this.state.amount,
            depositType : "flutterwave",
          };
    
          const headers = {
            authorization: `${this.token}`,
            "Content-Type": "application/json",
          };

          const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/wallet/deposit`;
          const paymentProcess = `${process.env.REACT_APP_API_ENDPOINT}/wallet/payments/flutterwave/process/`;

          const depositReq = await post(endpoint, obj, headers);

          const depositData = depositReq.data?.data?.deposit;
          localStorage.setItem("deposit_data", depositData);

          if (depositReq.status === "201") {
            this.setState({
              loading: false,
              flutterActive: true,
            });
          }

          appendScript(scriptUrl)
          this.FlutterwaveCheckout = window.FlutterwaveCheckout

          const fluCheckOut = this.FlutterwaveCheckout
          const userData = this.user;
          const setState = this.setState;

          function makePayment(payload) {
            if(fluCheckOut) {
              console.log("WILL LAUNCH FLUTTERWAVE CHECKOUT")
              // if(isDev) debugger;
              fluCheckOut(payload); // for reasons known to Flutterwave, the checkout sometimes doesn't respond 
            }
            else throw new Error("Failed to launch checkout action")
            // window.payload = payload;
          }
          // window.redodo = makePayment

          makePayment({
            public_key: process.env.REACT_APP_FLUTTERWAVE_PUBKEY,
            tx_ref: depositData?.reference,
            amount: Number(depositData?.amount["$numberDecimal"]),
            currency: String(depositData?.currency).toUpperCase(),
            country: countryMap(depositData?.currency),
            payment_options: " ",
            customer: {
              email: userData.email,
              phone_number: userData.phone,
              name: `${userData?.fullName}`,
            },
            callback: async function (data) { // specified callback function
              if(data?.status === "successful") {
                try {
                  // attempt to fast track receipt, incase webhook failed
                  if(data?.transaction_id) post(paymentProcess + data.transaction_id, {}, headers);
                  else if(data.id) post(paymentProcess + data.id, {}, headers);
                  console.log("posted flutterwave payment processing", data)
                } catch(err) {
                  console.log("error posting flutterwave payment processing")
                }
                await new Promise((resolve) => {
                  setTimeout(() => resolve(true), 1000)
                })
                removeScript(scriptUrl)
                window.location.replace(window.location.origin + "/dashboard/wallet")
                // setState({
                //   status: "depositSuccess",
                //   processing: false,
                // });
              } else {
                if(2+2===4) return; //TODO: debug the setState
                setState({
                  status: "depositFailed",
                  processing: false,
                });
              } 
            },
            customizations: {
              title: `Funds Deposit`,
              description: `Deposit of ${String(depositData?.currency).toUpperCase()}${Number(depositData?.amount["$numberDecimal"])}`,
              logo: "https://prod-doc.fra1.cdn.digitaloceanspaces.com/btm-assets/logo.png",
            },
          });
          ebtn?.classList?.remove("e-disable");
          loaded2?.classList?.remove("load-aa-on");
          
        } catch (err) {
          ebtn?.classList?.remove("e-disable");
          errmsg.classList.remove("err-auth-on");
          loaded2?.classList?.remove("load-aa-on");
          if(err?.customError) {
            this.props?.toast({
              position: "bottom-right",
              title: "Oop!!",
              description: err.customError,
              status: "error",
              duration: 9000,
              isClosable: true,
            });
            this.setState({
              errorMessage: err.customError,
              incorrectError: err.customError,
              processing: false,
            });
          } else if (err.isAxiosError) {
            // const errData = err.response;
            // const errmsg = document.getElementById("error-info");
            // errmsg.classList.add("error-info-on");
    
            // loaded2.classList.remove("load-aa-on");
            // ebtn.classList.remove("e-disable");
    
            if (err.isAxiosError) {
                this.setState({
                  //errorMessage: errData.data.error,
                  processing: false,
                });
              //}
            } else {
              this.setState({
                //errorMessage: errData.data.error,
                processing: false,
              });
             
            }
          }
        }
    }

    handleRemove = event => {
        event.preventDefault();
        this.setState({ status : "none" });
        this.setState({popUpRemove: true})
        setTimeout(function(){ 
            document.querySelector('#rem-box').style.display = "none" 
        }, 1000);
    }

    render() {

        const currentPage = "Home";

        return (
            <div>
                <Sidemenu currentPage={currentPage} />
                <Header />

                {this.state.status === "depositSuccess" && (
                    <div  id="rem-box" >
                        <div className="overlay animate__animated animate__fadeIn "></div>
                        <section className="popup">
                            <div className="popup-box animate__animated animate__slideInDown">
                                <div className="popup-img">
                                <img className=" animate__animated animate__slow animate__jackInTheBox animate__delay-.5s" src={Check2} alt="" />
                                </div>
                               <h2>{(this.state.currency).toUpperCase()}{this.state.amount}</h2>
                               <p className="popup-success">Wallet funded Successfully!</p>
                               <p onClick={this.handleRemove} className="popup-close">Close</p>
                               {/* {document.querySelector('#rem-box').style.display = "block"} */}
                            </div>
                        </section>
                    </div>
                )}

                {this.state.status === "depositFailed" && (
                    <div id="rem-box" >
                        <div className="overlay animate__animated animate__fadeIn "></div>
                        <section className="popup">
                            <div className="popup-box  redshade animate__animated animate__slideInDown">
                                <div className="popup-img">
                                <img className=" animate__animated animate__slow animate__jackInTheBox animate__delay-.5s" src={Check0} alt="" />
                                </div>
                               <h2>{this.state.amount}</h2>
                               <p className="popup-success">Wallet funding failed,<br /> Please try again.</p>
                               <p onClick={(e)=>this.setState({status : "none"})} className="popup-close">Close</p>
                               {/* {document.querySelector('#rem-box').style.display = "block"} */}
                            </div>
                        </section>
                    </div>
                )}

                {this.state.popUpRemove === true && (
                    <div id="rem-box">
                        <div className="overlay animate__animated animate__fadeOut "></div>
                        <section className="popup">
                            <div className="popup-box animate__animated animate__backOutUp">
                                <div className="popup-img">
                                <img className=" animate__animated animate__slow animate__jackInTheBox animate__delay-.5s" src={Check2} alt="" />
                                </div>
                                <h2>{(this.state.currency).toUpperCase()}{this.state.amount}</h2>
                               <p className="popup-success">Wallet funded Successfully!</p>
                               <p onClick={this.handleRemove} className="popup-close">Close</p>
                            </div>
                        </section>
                    </div>
                )}


                <section className="home">
                    <div
                    id="error-info2"
                    className="err-auth zindex animate__animated animate__slideInDown">
                        <p>
                            <strong>{this.state.incorrectError}</strong>
                        </p>
                    </div>
                    <div className="home-container">
                        <div className="home-buy-content">
                            <Link to="/dashboard/homefundwallet">
                            <img src={Back} className="w-backarrow" alt="back" />
                            </Link>
                            <h1> Fund with Flutterwave </h1>
                            <div className="home-nav">
                                <Link to="/dashboard/home" className="right-e"><p className="ash"> Home </p> </Link>
                                <img className="right-e" src={Arrow}alt="" />
                                <Link to="/dashboard/homefundwallet" className="right-e"><p className="ash"> Fund Wallet </p> </Link>
                                <img className="right-e" src={Arrow}alt="" />
                                <p><span className="bold"> Flutterwave Deposit</span></p>
                            </div>
                            <div className="depo-box">
                                <form onSubmit={this.handleSubmit} className="cardpayment-form">
                                    <div className="p2p-inputs">
                                        <input name="amount" onChange={this.handleInputChange}
                                        type="text" placeholder="Amount"/>
                                    </div>
                                    <div className="p2p-inputs">
                                        <select
                                            name="fiatCurrency"
                                            className="depo-select"
                                            onChange={this.handleInputChange}
                                            defaultValue={this.state.fiatCurrency}
                                            required
                                            >
                                            <option value="">Select Currency</option>
                                            {!isProd ? <option value="ngn">Nigerian Naira (NGN)</option> : null}
                                            <option value="ghs">Ghana Cedis (GHS)</option>
                                            <option value="kes">Kenya Shillings (KES)</option>
                                        </select>
                                        {/* <input type="text" /> */}
                                    </div>
                                    {/* <div className="cardinfos-box">
                                        <input className="carddate-input right-m2" type="text" placeholder="MM/YY" maxLength="5" />
                                        <input className="cardcode-input" type="text" placeholder="CVV" maxLength="3" />
                                    </div> */}
                                    <button  id="actionBtn"
                                    className="cardinfo-submit e-disable" type="submit">
                                        Fund Wallet
                                    </button>
                                    <div id="loadla" className="load-aa" >
                                        <img src={Load} alt="loading" />
                                    </div>
                                </form>
                            </div>
                            
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}
